module.exports = __webpack_public_path__ + "static/media/DSC_2913.600c6f92.jpg";